import { h } from 'preact';
import { FilterChips } from '../FilterChips';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'FilterChips',
  category: '📊 Data Display',
  description: 'Chips de filtro horizontal com scroll, contagem e tamanho sm',
  usedIn: ['Integrations', 'AgentesPage'],
  example: () => (
    <div>
      <FilterChips
        options={[
          { key: 'all', label: 'Todos', count: 12 },
          { key: 'active', label: 'Ativos', count: 8 },
          { key: 'inactive', label: 'Inativos', count: 3 },
          { key: 'pending', label: 'Pendentes', count: 1 },
        ]}
        selected="all"
        onChange={(key) => console.log(key)}
      />
      <div style={{ marginTop: 12, fontSize: 11, color: T.textMuted }}>Tamanho sm:</div>
      <FilterChips
        options={[
          { key: 'all', label: 'Todos' },
          { key: 'online', label: 'Online' },
          { key: 'offline', label: 'Offline' },
        ]}
        selected="all"
        onChange={(key) => console.log(key)}
        size="sm"
      />
    </div>
  ),
};
